import { render } from "./InjuryOccupationDisease.vue?vue&type=template&id=c59271fc&scoped=true"
import script from "./InjuryOccupationDisease.vue?vue&type=script&lang=js"
export * from "./InjuryOccupationDisease.vue?vue&type=script&lang=js"

import "./InjuryOccupationDisease.vue?vue&type=style&index=0&id=c59271fc&lang=scss&scoped=true"
import "./InjuryOccupationDisease.vue?vue&type=style&index=1&id=c59271fc&lang=scss&scoped=true"
import "./InjuryOccupationDisease.vue?vue&type=style&index=2&id=c59271fc&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c59271fc"]])

export default __exports__